import Vue from 'vue/dist/vue.esm.js';

Vue.component('contact', {
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      timeToCall: undefined,
      topic: '',
      comments: '',
      city: '',
      age: '',
      sex: '',
      weight: '',
      height: '',
      defaultTopic: '',
      sweet: '',
      mouseMoved: 0,
      pageTouch: 0,
      keyPress: 0,
      showThankyou: false
    }
  },
  computed: {
    firstNameValid: function(){
      var re = /^[a-zA-Z][a-z'-]+$/i;
      return re.test(this.firstName);
    },
    lastNameValid: function(){
      var re = /^[a-zA-Z][a-z'-]+$/i;
      return re.test(this.lastName);
    },
    emailValid: function(){
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },
    phoneValid: function(){
      var re = /^(04)(?:\s*\d){8}$/;
      return re.test(this.phone);
    },
    timeToCallValid: function(){
      return this.timeToCall != undefined;
    },
    topicValid: function(){
      return this.topic != '';
    },
    commentsValid: function(){
      return this.commetns != '';
    },
    sweetFilled: function(){
      return this.sweet != '';
    },
  },
  mounted(){
    this.topic = this.defaultTopic;
    this.runBotChecks()
  },
  watch: {
    topic: function(oldVal, newVal){
    },
    defaultTopic: function(oldVal, newVal){
    }
  },
  methods: {
    runBotChecks: function(){

      document.onmousemove = ()=>{
        if(this.mouseMoved < 10){
          this.mouseMoved += 1;
        }
      }

      document.ontouchstart = ()=>{
        if(this.pageTouch < 5){
          this.pageTouch += 1;
        }
      }

      document.onkeydown = ()=>{
        if(this.keyPress < 30){
          this.keyPress += 1;
        }
      }


    },
    setDefaultTopic: function(topic){
      this.defaultTopic = topic
    },
    submitContactForm: function(e){
      e.preventDefault();

      if(!this.firstNameValid || !this.lastNameValid || !this.emailValid || !this.phoneValid){
        return;
      }

      // Set as spam by default
      let endpoint = '6/feedback';

      var formData = new FormData();
      formData.append("first-name", this.firstName);
      formData.append("surname", this.lastName);
      formData.append("email", this.email);
      formData.append("mobile", this.phone);
      formData.append("time-to-call", this.timeToCall);
      formData.append("enquiry", this.topic);
      formData.append("comments", this.comments);
      formData.append("city", this.city);
      formData.append("age", this.age);
      formData.append("sex", this.sex);
      formData.append("weight", this.weight);
      formData.append("height", this.height);


      fetch(`/wp-json/contact-form-7/v1/contact-forms/${endpoint}`, {
        method: 'POST', // or 'PUT'
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        this.showThankyou = true;
      })
      .catch((error) => {
        // console.error('Error:', error);
      });

    }
  }
});

new Vue({}).$mount('#contactWrapper');
